module.exports = __webpack_public_path__ + "static/media/print-header-bg.26841627.png";